var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-tab-filter-control"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_vm._t("default",function(){return [_vm._v("Default Slot")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }